import ApplicationController from './application'

export default class extends ApplicationController {
  static targets = ['select', 'button']
  static values = { original: Number }

  connect() {
    console.log('ProfitShareForm controller connected', this.originalValue)
    this.checkChange()
  }

  checkChange() {
    const currentValue = parseInt(this.selectTarget.value, 10)
    const changed = currentValue !== this.originalValue
    console.log('Checking change:', { currentValue, original: this.originalValue, changed })

    if (changed) {
      this.buttonTarget.disabled = false
      this.buttonTarget.style.backgroundColor = '#10b981'
      this.buttonTarget.style.color = 'white'
      this.buttonTarget.style.cursor = 'pointer'
    } else {
      this.buttonTarget.disabled = true
      this.buttonTarget.style.backgroundColor = '#d1d5db'
      this.buttonTarget.style.color = '#6b7280'
      this.buttonTarget.style.cursor = 'not-allowed'
    }
  }
}
